<script>
import Loading from '../../components/loading.vue';
export default {
    name: "order",
    data() {
        return {
            list: [
                {
                    id: 1,
                    image: '',
                    time: '2025-06-26',
                    order_code: '1234567899874562',
                    name: '金满勇限量联名手机壳',
                    count: 1,
                    price: '45.00',
                    isShowLogistics: false,
                },
                {
                    id: 2,
                    image: '',
                    time: '2025-06-26',
                    order_code: '1234567899874562',
                    name: '金满勇限量联名手机壳',
                    count: 1,
                    price: '45.00',
                    isShowLogistics: false,
                },
            ],
            isLoading: false,
        };
    },
    computed: {},
    components: {
        Loading
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="order">
        <p class="title">我的订单</p>
        <div class="loading_wrap" v-if="isLoading">
            <Loading/>
        </div>
        <p class="no_more" v-else-if="list.length == 0">你还没有选购商品<router-link to="/shop">立即去购物&gt;&gt;</router-link></p>
        <div class="order_list" v-else>
            <div class="item thead">
                <div class="tr">
                    <div class="td">订单信息</div>
                    <div class="td">商品价格</div>
                    <div class="td">实付款</div>
                    <div class="td">订单操作</div>
                </div>
            </div>
            <div class="item" v-for="(item, index) in list" :key="index">
                <div class="top flex align_center">
                    <p class="time">{{item.time}}</p>
                    <p class="code">订单号：{{item.order_code}}</p>
                </div>
                <div class="tr">
                    <div class="td">
                        <div class="info">
                            <router-link class="cover" :style="`background-image: url(${item.image});`" :to="`/shop/detail?id=${item.id}`"></router-link>
                            <div class="wrapper">
                                <p class="name">
                                    <router-link :to="`/shop/detail?id=${item.id}`">{{item.name}}</router-link>
                                </p>
                                <div class="info_btn_group">
                                    <div class="btn layout_flex_center">加入购物袋</div>
                                    <router-link class="btn layout_flex_center" :to="`/mine/order/afterSale?id=${item.id}`">申请售后</router-link>
                                </div>
                            </div>
                            <p class="count layout_flex_center">x{{item.count}}</p>
                        </div>
                    </div>
                    <div class="td price layout_flex_center">RMB {{item.price}}</div>
                    <div class="td layout_flex_center">
                        <p class="price2">实际付款：RMB {{item.price}}<br/>含运费：RMB 0.00</p>
                    </div>
                    <div class="td layout_flex_center">
                        <div class="btn_group">
                            <div class="btn layout_flex_center type1">再次购买</div>
                            <div class="btn layout_flex_center">
                                <div class="text" @click="item.isShowLogistics = !item.isShowLogistics">查看物流</div>
                                <div class="logistics flex align_center" v-if="item.isShowLogistics">
                                    <p class="name">顺丰快递</p>
                                    <p class="code">15892233668852444782</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.order{
    .order_list{
        .tr{
            .td{
                &:nth-of-type(1){
                    width: 38%;
                }
                &:nth-of-type(2){
                    width: 15%;
                }
                &:nth-of-type(3){
                    width: 20%;
                }
                &:nth-of-type(4){
                    width: 27%;
                }
            }
        }
    }
}
</style>